import Vue from "vue";
import App from "./App";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import store from "./vuex/store";
import Vuex from "vuex";
import router from "./router/index";
import axios from "./utils/axios";
import dayjs from 'dayjs';
import "font-awesome/css/font-awesome.min.css";
import VueRouter from "vue-router";
import locale from 'element-ui/lib/locale/lang/en'

Vue.use(ElementUI, { locale });
Vue.use(Vuex);
Vue.prototype.$http = axios;
Vue.prototype.$dayjs = dayjs;

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");

  // 未登录 → 跳登录页（仅拦截非登录页）
  if (!token && to.path !== "/login") {
    next({ path: "/login" });
    return;
  }

  // 已登录 → 根路径跳table（仅一次重定向）
  if (token && to.path === "/") {
    next({ path: "/table" });
    return;
  }

  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");